module.exports = __webpack_public_path__ + "img/Phone_02.eef663c7.jpg";